var _templateObject = _taggedTemplateLiteralLoose(['\n  /* margin-top: 0px;\n  margin-bottom: 0px; */\n  font-size: 13px;\n  color: ', ';\n  ul {\n    color: ', ';\n  }\n'], ['\n  /* margin-top: 0px;\n  margin-bottom: 0px; */\n  font-size: 13px;\n  color: ', ';\n  ul {\n    color: ', ';\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var HintText = styled.p(_templateObject, function (props) {
  return props.theme.colours.neutral.darker;
}, function (props) {
  return props.theme.colours.neutral.darker;
});

var Hint = function Hint(props) {
  return React.createElement(HintText, null, props.children);
};

export default Hint;